// extracted by mini-css-extract-plugin
module.exports = {"quoteWrapper":"e5","quote":"e6","quoteAuthor":"e7"};